import { create } from 'zustand';

interface SnackState {
  open: boolean;
  type: 'error' | 'success' | 'info';
  message: string;
}

interface SnackStore extends SnackState {
  setSnack: (state: SnackState) => void;
  closeSnack: () => void;
}

const useSnackStore = create<SnackStore>((set) => ({
  open: false,
  type: 'success',
  message: '',
  setSnack: (state) => set(state),
  closeSnack: () => set({ open: false, message: '' }),
}));

export { useSnackStore };
